import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@components';
import { faLock } from '@fortawesome/free-solid-svg-icons';
import { setWindowClass } from '@app/utils/helpers';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Form, InputGroup } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {  setPassword } from '@app/services/auth';
import { useDispatch } from 'react-redux';
import { setRecoverPasswordEmail } from '@app/store/reducers/auth';

const SetPassword = () => {
	const [t] = useTranslation();
	const [isLoading, setLoading] = useState(false);
	const navigate = useNavigate();
	const dispatch = useDispatch();
	let { id, token } = useParams();
	
	const setPasswordAPI = async (payload) => {
		try {
			setLoading(true);
			const resp = await setPassword(payload);
			if (resp.success === true) {
				setLoading(false);
				dispatch(setRecoverPasswordEmail(''));
				toast.success(resp?.message);
				navigate('/login');
			} else {
				setLoading(false);
				toast.error(resp?.errors[0]?.msg);
			}
		} catch (error: any) {
			setLoading(false);
			toast.error(error?.message || 'Internal Server Error');
		}
	}

	const { handleChange, values, handleSubmit, touched, errors } = useFormik({
		initialValues: {
			id: id,
			reset_token: token,
			password: '',
			confirmPassword: ''
		},
		validationSchema: Yup.object({
			password: Yup.string()
				.min(8, 'Must be 8 characters or more')
				.max(30, 'Must be 30 characters or less')
				.required('New password is required'),
			confirmPassword: Yup.string()
				.min(8, 'Must be 8 characters or more')
				.max(30, 'Must be 30 characters or less')
				.required('Confirm password is required')
				.when('password', {
					is: (val: string) => !!(val && val.length > 0),
					then: Yup.string().oneOf(
						[Yup.ref('password')],
						'Passwords do not match.'
					)
				})
		}),
		onSubmit: (values) => {
			setPasswordAPI(values);
		}
	});

	setWindowClass('hold-transition login-page');
	return (
		<div className="login-box">
			<div className="card card-outline card-primary">
				<div className="card-header text-center">
					<Link to="/" className="h1">
						{/* <b>FCL </b> */}
						<span>{t('setPassword.heading')}</span>
					</Link>
				</div>
				<div className="card-body">
					<p className="login-box-msg">{t('setPassword.oneStepAway')}</p>
					<form onSubmit={handleSubmit}>
						<div className="mb-3">
							<InputGroup className="mb-3">
								<Form.Control
									id="password"
									name="password"
									type="password"
									placeholder="Enter new password"
									onChange={handleChange}
									value={values.password}
									isValid={touched.password && !errors.password}
									isInvalid={touched.password && !!errors.password}
									onFocus={e => e.target.select()}
									key="5"
								/>
								{touched.password && errors.password ? (
									<Form.Control.Feedback type="invalid">
										{errors.password}
									</Form.Control.Feedback>
								) : (
									<InputGroup.Append>
										<InputGroup.Text>
											<FontAwesomeIcon icon={faLock} />
										</InputGroup.Text>
									</InputGroup.Append>
								)}
							</InputGroup>
						</div>
						<div className="mb-3">
							<InputGroup className="mb-3">
								<Form.Control
									id="confirmPassword"
									name="confirmPassword"
									type="password"
									placeholder="Re-enter new password"
									onChange={handleChange}
									value={values.confirmPassword}
									isValid={touched.confirmPassword && !errors.confirmPassword}
									isInvalid={
										touched.confirmPassword && !!errors.confirmPassword
									}
								/>
								{touched.confirmPassword && errors.confirmPassword ? (
									<Form.Control.Feedback type="invalid">
										{errors.confirmPassword}
									</Form.Control.Feedback>
								) : (
									<InputGroup.Append>
										<InputGroup.Text>
											<FontAwesomeIcon icon={faLock} />
										</InputGroup.Text>
									</InputGroup.Append>
								)}
							</InputGroup>
						</div>
						<div className="row">
							<div className="col-12">
								<Button type="submit" block isLoading={isLoading}>
									{/* @ts-ignore */}
									{t('setPassword.button')}
								</Button>
							</div>
						</div>
					</form>
					<p className="mt-3 mb-1">
						<Link to="/login">Back to Login </Link>
					</p>
				</div>
			</div>
		</div>
	);
};

export default SetPassword;
